const numberOrZero = (numberValue: number | undefined | null) => numberValue ?? 0
export default numberOrZero
